import styled from "styled-components";
import Marquee from "react-fast-marquee";

const Contact = () => {
  return (
    <Section>
      <p id="contact">Got a project, an internship or a job opening?</p>
      <p>Feel free to reach out</p>
      <div className="contact">
        <Marquee pauseOnHover={true} gradient={false} speed={100}>
          <a href="mailto:iretomiwajonathan@gmail.com">
            CONTACT ME - LET'S WORK TOGETHER - LET ME WORK WITH YOU -
          </a>
        </Marquee>
      </div>
    </Section>
  );
};

const Section = styled.section`
  margin-top: 6rem;
  width: 100%;
  min-height: 30vh;
  p {
    text-align: center;
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    line-height: 0.5rem;
  }
  .contact {
    border-top: 2px solid #aaaaaa;
    border-bottom: 2px solid #aaaaaa;
    padding: 1rem 0;
    a {
      font-family: "Antonio", sans-serif;
      font-weight: 700;
      font-size: 6rem;
      overflow: hidden;
      position: relative;
      background: linear-gradient(to right, #1b9cf1, #1b9cf1 50%, #aaaaaa 50%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 200% 100%;
      background-position: 100%;
      transition: background-position 0.5s ease;
      &:hover {
        background-position: 0 100%;
      }
    }
  }

  @media screen and (max-width: 600px) {
    p {
      font-size: 1rem;
    }

    .contact {
      a {
        font-size: 4rem;
      }
    }
  }
`;

export default Contact;
